
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import MissionStatement from './components/MissionStatement';
import CoreBusiness from './components/CoreBusiness';
import AIProducts from './components/AIProducts';
import CaseStudies from './components/CaseStudies';
import NewsSection from './components/NewsSection';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <HeroCarousel />
      <MissionStatement />
      <CoreBusiness />
      <AIProducts />
      <CaseStudies />
      <NewsSection />
      <ContactCTA />
      <Footer />
    </div>
  );
}
